module.exports = __webpack_public_path__ + "img/ic-auto.b43ea278.svg";